// extracted by mini-css-extract-plugin
export default {"code":"K_cq"};